var samplePage = function (s, s_account) {
	'use strict';
	
	var sampleForm = new forms4i(),
	sampleRequestForm = document.getElementById("SampleRequestForm"),
	
	thankYouMessage = document.getElementById("thankYouMessage"),
	successMessage = document.getElementById("successMessage"),
	errorMessage = document.getElementById("errorMessage"),
	loadingIcon = document.getElementById("loadingIcon"),
	
	getAjaxHeader = function(selector) {
		return { "__RequestVerificationToken": selector.getElementsByTagName('input')[0].getAttribute("value") };
	},	
	omniture = (function (s, s_account) {
		    var account = s_account ? s_account : "4imprintprod",
		
		    sampleSuccess = function (catAlias) {
		        s.pageName = "Sample Request Confirmation";
		        s.events = "event25";
		        s.channel = "Sample Request";
		        s.eVar29 = "successful request:" + catAlias;
		        s.t();
		    },
		
		    sampleInvalid = function () {
		        s.pageName = "Sample Request Confirmation";
		        s.channel = "Sample Request";
		        s.eVar29 = "banned or invalid";
		        s.t();
		    },
		
		    sampleModelInvalid = function () {
		        s.pageName = "Sample Request Confirmation";
		        s.channel = "Sample Request";
		        s.eVar29 = "invalid";
		        s.t();
		    },
		
		    sampleBanned = function (catAlias) {
		        s.pageName = "Sample Request Confirmation";
		        s.channel = "Sample Request";
		        s.eVar29 = "banned:" + catAlias;
		        s.t();
		    };
		
		    return {
		        SampleSuccess: sampleSuccess,
		        SampleInvalid: sampleInvalid,
		        SampleModelInvalid: sampleModelInvalid,
		        SampleBanned: sampleBanned
		    };
		}(s, s_account)),
	
	submitSampleRequest = function() {
		loadingIcon.classList.remove("hide");
		
		var sampleRequest = {
			FirstName: document.getElementById("FirstName").value,
			LastName: document.getElementById("LastName").value,
			CompanyName: document.getElementById("CompanyName").value,
			Address1: document.getElementById("Address1").value,
			Address2: document.getElementById("Address2").value,
			City: document.getElementById("City").value,
			State: document.getElementById("State").value,
			ZipCode: document.getElementById("ZipCode").value,
			PhoneNumber: document.getElementById("PhoneNumber").value,
			PhoneExt: document.getElementById("PhoneExt").value,
			Email: document.getElementById("Email").value,
			ProductName: document.getElementById("ProductName").value,
			CatalogAlias: document.getElementById("CatalogAlias").value,
			Comments: document.getElementById("Comments").value
		};
		
		document.getElementById("btnSubmitSampleReq").disabled = true;
		
		var sampleRequestSubmit = ajax({
    			method: "POST",
                    url: "/samples/submitsamplerequest",
                    data: sampleRequest,
                    headers: getAjaxHeader(sampleRequestForm)
		});
		
         	sampleRequestSubmit.then(function (response, xhr) {
         		if (!response.modelStateInvalid) {
	   			thankYouMessage.classList.remove("hide");
				sampleRequestForm.classList.add("hide");
				if (!response.success) {
					errorMessage.classList.remove("hide");
					if (response.RequestLimitHit != null && response.RequestLimitHit == true) {
						document.getElementById("errorDiv").classList.add("hide");
						omniture.SampleInvalid();
					}
					else {
						document.getElementById("limitDiv").classList.add("hide");
					}
					successMessage.classList.add("hide");
				}else{
					if(response.special != null && response.special === true){
						omniture.SampleBanned(sampleRequest.CatalogAlias);
					}else{
						omniture.SampleSuccess(sampleRequest.CatalogAlias);
					}
				}
				thankYouMessage.scrollIntoView({behavior: "smooth"});
				
			}
			else {
	    			var formHeading = document.getElementsByClassName("formHeading")[0];
				formHeading.insertAdjacentHTML('afterend', response.validationSummary);
	    			formHeading.scrollIntoView({behavior: "smooth"});
	    			loadingIcon.classList.add("hide");
	    			omniture.SampleModelInvalid();
	    			
			}
			document.getElementById("btnSubmitSampleReq").disabled = false;
    	  	});
    	  	
          	sampleRequestSubmit.catch(function(response, xhr){
   			thankYouMessage.classList.remove("hide");
			sampleRequestForm.classList.add("hide");
			errorMessage.classList.remove("hide");
			document.getElementById("limitDiv").classList.add("hide");
			successMessage.classList.add("hide");
			thankYouMessage.scrollIntoView({behavior: "smooth"});
			document.getElementById("btnSubmitSampleReq").disabled = false;
	    	});
	},
	
	formSuccess = function() {
		submitSampleRequest();
    		thankYouMessage.scrollIntoView({behavior: "smooth"});
    		if (document.getElementById("returnButton")) { // necessary if we're on inline form without a return button
    		   	document.getElementById("returnButton").focus();
    		}
	},

	init = function(){
		if(document.getElementById("ZipCode")){
			var zipCodeMaskPattern = document.getElementById("ZipCodeMask").value;
			if (zipCodeMaskPattern != "") { // only used for CA
				VMasker(document.getElementById("ZipCode")).maskPattern(zipCodeMaskPattern);
			}
		}
		if (document.getElementById("cancelSampleRequest")) {
			document.getElementById("cancelSampleRequest").addEventListener("click", function(e){
			e.preventDefault();
			if (this.href == "") { // this means we're on the inline page
				sampleRequestForm.classList.add("hide");
				document.getElementsByClassName("sampleBtnContainer")[0].style.display = "";
				var sampleCancel = document.createElement('p');
				sampleCancel.classList.add("sampleCancel");
				sampleCancel.classList.add("clear");
				sampleCancel.classList.add("textsemibold");
				sampleCancel.classList.add("marginTop10");
				sampleCancel.classList.add("textBlue");
				sampleCancel.innerHTML = "Your sample request has been cancelled.";
				var role = document.createAttribute("role");
				role.value = "status"; 
				document.getElementsByClassName("sampleRequestPanel")[0].appendChild(sampleCancel);
				document.getElementsByClassName("sampleRequestPanel")[0].scrollIntoView({behavior: "smooth"});
			}
			else {
				window.location.href = this.href;
			}
		});
		document.getElementById("cancelSampleRequest").addEventListener("keypress", function(e){
			if (e.type =='keypress' && e.which == 13) { 
				e.preventDefault();
				if (this.href == "") { // this means we're on the inline page
					sampleRequestForm.classList.add("hide");
					document.getElementsByClassName("sampleBtnContainer")[0].style.display = "";
					var sampleCancel = document.createElement('p');
					sampleCancel.classList.add("sampleCancel");
					sampleCancel.classList.add("clear");
					sampleCancel.classList.add("textsemibold");
					sampleCancel.classList.add("marginTop10");
					sampleCancel.classList.add("textBlue");
					sampleCancel.innerHTML = "Your sample request has been cancelled.";
					var role = document.createAttribute("role");
					role.value = "status"; 
					document.getElementsByClassName("sampleRequestPanel")[0].appendChild(sampleCancel);
					document.getElementsByClassName("sampleRequestPanel")[0].scrollIntoView({behavior: "smooth"});
				}
				else {
					window.location.href = this.href;
				}
			}
		});
		}

		if (document.getElementById("btnSubmitSampleReq")) {
		
			document.getElementById("btnSubmitSampleReq").addEventListener("click", function(e){
				e.preventDefault();
				sampleForm.formValidation(sampleRequestForm, formSuccess, e);
			});
			
			document.getElementById("btnSubmitSampleReq").addEventListener("keypress", function(e) {
				if (e.type =='keypress' && e.which == 13) { 			
					e.preventDefault();
					sampleForm.formValidation(sampleRequestForm, formSuccess, e);
				}
			});
		}
	}
	
	

	return {
		init: init
	};
};

(function(){
	var loadSample = new samplePage(s, s_account);
	loadSample.init();
})();